import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ReportObjectPayments, ReportObjectPaymentsProvider } from 'modules/admin';
import { useObjectCard } from '../context/ObjectCardProvider';

interface OffObjectPaymentsReportProps {
    show: boolean;
    onHide: () => void;
    objectId: number;
}

const OffObjectPaymentsReport = ({ show, onHide, objectId }: OffObjectPaymentsReportProps) => {
    const { t } = useTranslation(['Objects']);
    const { vObject } = useObjectCard();
    const objectName = vObject?.object?.objectName || vObject?.object?.clientName || '';
    return (
        <Offcanvas placement="end" className="off-import off-object-payments-report" show={show} onHide={onHide}>
            <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title>{t('listColumns.payments')} {objectName}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0 pt-1">
                <div className="off-coming-form d-flex flex-column h-100">
                    <div className="off-coming-content px-3">
                        {show && objectId > 0 && (
                            <ReportObjectPaymentsProvider key={objectId} objectId={objectId}>
                                <ReportObjectPayments /> 
                            </ReportObjectPaymentsProvider>
                        )}
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffObjectPaymentsReport;
